module.exports = __webpack_public_path__ + "img/rules-title.f7f60914.png";